import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-processing-sales-and-refunds-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Trading outside of linked POS policy</span>
      <div articleBody class="body-1-regular-1">

        <section>
          <div class="heading">Impact</div>
          <div>
            Trading outside of Lightspeed Retail-X (VEND) causes discrepancies in sales figures between the Nter
            platform, card payment devices such as YOCO and the connected POS such as Lightspeed Retail-X (VEND).
          </div>
        </section>

        <section>
          <div class="heading">Reconciliation and delayed automated pay-outs</div>
          <ul>
            <li>
              In order to accurately pay-out transactions performed outside of Lightspeed Retail-X (VEND), the missing
              sales data needs to be captured on Lightspeed Retail-X (VEND), which will facilitate the accurate
              allocation of funds and reporting.
            </li>
            <li>
              Discrepancies are identified via monthly reconciliations performed by Nter.
            </li>
          </ul>
        </section>

        <section>
          <div class="heading">Authorization to reconcile sales on Client’s behalf</div>
          <div>To rectify the discrepancies, Nter will:</div>
          <ol>
            <li>
              Request confirmation to capture missing sales data on the respective Lightspeed VEND accounts, on the
              landlord’s behalf.
            </li>
            <li>
              An authorization request will be shared with the client (landlord) for approval before sales are captured
              on Lightspeed Retail-X (VEND) accounts.
            </li>
            <li>
              Upon receipt of the signed authorization, initiate the sales capture process.
            </li>
            <li>
              Proceed with the transaction processing activities.
            </li>
          </ol>
        </section>

        <section>
          <div class="heading">Associated fees for time spent</div>
          <div>
            Clients (landlords) may be charged for capturing sales data and to facilitate the reconciliation process
            without prior notice.
          </div>
        </section>
      </div>
    </app-policy-article>
  `
})
export class TradingOutsideOfLinkedPosArticleComponent {

}
